<template>
    <div class="chat-toast">
    	<transition-group name="fadeZoom" tag="div">
    		<div class="message" :key="item.id" :style="item.style" v-html="item.message" v-for="item in messageList"></div>
    	</transition-group>
    </div>
</template>

<script>
    export default {
        name: 'chat-toast',
        props: {
        	config: {
        		type: Object,
        		default: () => {
        			return {
        				delay: 4000,
        				color: '#FFFFFF',
        				bgColor: '#333333',
        				// 以下是固定
        				fontSize: '12px',
        				maxNumber: 3
        			} 
        		}
        	}
        },
        data() {
        	return {
        		messageId: 0,
        		messageList: []
        	}
        },
        methods: {
        	showToast(data) {
        		const _data = typeof data === 'string' ? { message: data } : data;
        		if (String(_data.message)) {
        			let id = this.messageId,
        				style = '',
        				timer = null,
        				delay = 4000,
        				message = String(_data.message),
        				color = _data.color || '#FFFFFF',
        				bgColor = _data.bgColor || '#333333';
        			if (_data.delay) {
        				if (isNaN(_data.delay) === false) {
        					if (Number(_data.delay) > 3500) {
        						delay = Number(_data.delay);
        					}
        				}
        			}
        			const messageObj = {
        				id,
        				timer,
        				delay,
        				style,
        				message,
        				rawStyle: `color: ${color};font-size: ${this.fontSize};background-color: ${bgColor};`
        			};
        			this.messageId += 1;
        			// 新增消息超过消息列表最大数量，将第一条消息删除
        			if (this.messageList.length === Number(this.maxNumber)) {
        				clearTimeout(this.messageList[0].timer);
        				this.messageList.shift();
        			}
        			// 开启消息到时自我删除
        			messageObj.timer = setTimeout(() => {
        				clearTimeout(messageObj.timer);
        				let index = this.messageList.findIndex(v => v.id === messageObj.id);
        				if (index > -1) {
        					this.messageList.splice(index, 1);
        				}
        			}, messageObj.delay + 300 * 2);
        			// 将最新消息添加到消息队列
        			const length = this.messageList.length;
        			this.messageList.push(messageObj);
        			// 调整消息队列位置
        			this.messageList.forEach((v, i) => {
        				v.style = v.rawStyle + `bottom: ${(length - i) * this.bottom}px;`;
        			});
        		}
        	}
        },
        computed: {
        	bottom() {
        		let bottom = Number(this.fontSize.slice(0, this.fontSize.length - 2)) || 12;
        		return Number(bottom) - 12 + 40; 
        	},
        	fontSize() {
        		// 只接受px
        		return this.config.fontSize || '12px';
        	},
        	maxNumber() {
        		if (this.config.maxNumber) {
        			if (isNaN(this.config.maxNumber) === false) {
        				if (Number(this.config.maxNumber)) {
        					return Number(this.config.maxNumber);
        				}
        			}
        		}
        		return 3;
        	}
        }
    }
</script>

<style scoped lang="less">
    .chat-toast{
    	width: 100%;
    	min-height: 30px;
    	position: relative;
    	z-index: 91;
        .message{
        	position: absolute;
        	left: 50%;
        	transform: translateX(-50%);
        	padding: 6px 15px;
        	border-radius: 3px;
        	white-space: normal;
        	transition: bottom 0.3s ease-in;
        	box-shadow: 0 3px 10px #333333;
        }
        .fadeZoom-enter-active{
        	animation: fadeZoom 0.3s ease-in forwards;
        }
        .fadeZoom-leave-active{
        	animation: fadeZoom 0.3s ease-in forwards reverse;
        }
        @keyframes fadeZoom{
        	0%{
        		opacity: 0;
        		transform: translateX(-50%) scale(0.8);
        	}
        	70%{
        		opacity: 0.75;
        		transform: translateX(-50%) scale(1.2);
        	}
        	100%{
        		opacity: 1;
        		transform: translateX(-50%) scale(1);
        	}
        }
    }
</style>
